import React, { useEffect, useRef, useState } from "react";
import DelegationComponent from "../Task/DelegationComponent";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import useRequireAuth from "../../utils/useRequireAuth";
import DelegationMultiSelect from "../Task/DelegationMultiSelect";

const PersonSelect = ({ value, isFormDisabled, multiSelect, onChange = () => {}, noLabel }) => {
  const [formData, setFormData] = useState({ assigned_to: value || [] });

  // useEffect(() => {
  //   onChange({value:formData?.assigned_to});
  // }, [formData?.assigned_to]);
  const taskassignedtoref = useRef(null);
  const token = useRequireAuth();
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  const [searchTerm, setSearchTerm] = useState({});

  const handleCheck = (index, event) => {
    setSearchTerm((prevState) => ({
      ...prevState,
      [index]: event.target.value,
    }));
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();
  // const [dropdownCoord, setDropdownCoord] = useState(null);
  const [isSearchBarOpen, setIsSearchBarOpen] = React.useState(false);

  const handleSelectPerson = (event, value, personCountAllowed) => {
    event.preventDefault();

    const isTaskCategory = formData?.category_id?.toLowerCase() === "task";
    const currentAssignedTo = formData.assigned_to || [];

    if (isTaskCategory) {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...formData?.assigned_to, value]?.slice(-personCountAllowed),
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: [],
        });
      }
    } else {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...currentAssignedTo, value],
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: currentAssignedTo.filter((item) => item !== value),
        });
      }
    }
  };

  const handleRemovePerson = (e, person) => {
    e.stopPropagation();
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: prevFormData.assigned_to.filter((item) => item.id !== person.id),
    }));
  };

  const handleMouseEnter = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: true,
    }));
    // setDropdownCoord((prevState) => {
    //   return getCreatePortalPosition();
    // });
    fetchPersonData("");
  };

  const handleMouseLeave = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    // setDropdownCoord(null);
  };

  const getCreatePortalPosition = () => {
    if (taskassignedtoref.current) {
      const rect = taskassignedtoref.current.getBoundingClientRect(); // Get the bounding rectangle

      const left = rect.left + 18;
      const top = rect.top + 5;

      return {
        top: top + window.scrollY,
        left: left + window.scrollX,
        borderRadius: "5",
      };
    }
  };

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId?.company_id });
  };

  return (
    <div className="w-[20vw]">
      <DelegationMultiSelect
        formData={formData}
        isFormDisabled={isFormDisabled}
        isSearchBarOpen={isSearchBarOpen}
        taskassignedtoref={taskassignedtoref}
        handleMouseEnter={handleMouseEnter}
        handleMouseLeave={handleMouseLeave}
        handleCheck={handleCheck}
        personTableData={personTableData}
        handleSelectPerson={handleSelectPerson}
        handleRemovePerson={handleRemovePerson}
        searchTerm={searchTerm}
        showSearchBar={true}
        // isEditTask={isEditTask}
        depth="D0"
        personCountAllowed={multiSelect ? 20 : 1}
        noLabel={noLabel}
      />
    </div>
  );
};

export default PersonSelect;
